<template>
  <div class="animated fadeIn text-center">
    <b-row>
      <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
        <strong>Get Country Info From the IP Address(GEO-IP)</strong>
      </b-col>
      <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
        <b-form-group>
          <div class="checkbox-switch">
            <input type="checkbox" class="input-checkbox" name="switch06" id="switch06" label variant="pill" size="sm" defaultChecked v-model="use_geoip" @change="change_use_geoip" :disabled="country_lock">
            <div class="checkbox-animate disabled">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
        </b-form-group>
      </b-col>
      <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
        <strong>Please select the country where firewall mode is applied.</strong>
      </b-col>
      <b-col class="col-xl-5 col-md-12 d-flex align-self-center">
        <b-form-input :disabled="!use_geoip" style="display:inline-block" v-model="country" placeholder="Enter Country name"></b-form-input>
      </b-col>
      <b-col class="col-xl-1 col-md-12 align-self-center text-left">
        <b-form-checkbox :disabled="!use_geoip" v-model="select_all" @change="toggle_all">
          Select All
        </b-form-checkbox>
        <b-form-checkbox :disabled="!use_geoip" v-model="show_block_only" @change="save_show_status">
          Only Selected
        </b-form-checkbox>
      </b-col>
      <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
        <div class="pull-right">
          <b-button size="sm" variant="outline-info" @click="explain_modal = true"><i class="fa fa-question"></i></b-button>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3 ml-3">
      <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
        <strong>Selected Country</strong>
      </b-col>
      <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
        {{country_code.length}}
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col class="col-xl-12 col-md-12 align-self-center">
        <div class="pr-2 pl-2" v-show="(is_show(x) && !show_block_only) || (show_block_only && x.is_block)" v-for="(x, index) in country_info" :key="index" style="min-width:75px; height:75px; display:inline-block;">
          <b-form-checkbox :disabled="!use_geoip" style="cursor:pointer;" v-model="x.is_block" class="is_check" @change="onSelect(x.Code, x.Name)">
            <CountryFlag class="explain" style="cursor:pointer;"  :country="x.Code" size='normal'/>
            <p :style="x.is_block ? 'font-weight:900' : ''">{{ country ? x.Name : x.Code}}</p>
          </b-form-checkbox>
        </div>
      </b-col>
    </b-row>
    <!-- 설명 모달 영역 -->
    <b-modal title="Block Base Country Code"  class="modal-info" v-model="explain_modal" ok-variant="outline-primary" header-bg-variant="add" ok-only>
      <p>For country code blocking, you must use the GEO-IP function to convert IP to country</p>
      <p>123.123.123.123 	&rArr; KR  </p>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
